import { env, Env } from 'core/config';
import { AtsProvider, IntegrationCredentials } from '../types';

const isSandbox = env.STAGE === Env.dev || env.STAGE === Env.staging;

export const getAtsCandidateUrl = ({
  integrationCredentials,
  atsCandidateId,
  atsApplicationId
}: {
  integrationCredentials: IntegrationCredentials | null;
  atsCandidateId: string | null | undefined;
  atsApplicationId: string | null | undefined;
}) => {
  if (!integrationCredentials || !atsCandidateId) {
    return null;
  }

  const { appSubdomain, provider } = integrationCredentials;

  if (
    appSubdomain &&
    (provider === AtsProvider.bullhorn_ats || provider === AtsProvider.bullhorn)
  ) {
    return `https://${appSubdomain}.bullhornstaffing.com/BullhornSTAFFING/OpenWindow.cfm?Entity=Candidate&id=${atsCandidateId}`;
  }

  if (provider === AtsProvider.lever && atsApplicationId) {
    // TODO: Handle sandbox environment in the future by exposing a sandbox variable at the integration level
    return `https://hire.${
      isSandbox ? 'sandbox.' : ''
    }lever.co/candidates/${atsApplicationId}`;
  }
};
